<template>
    <v-list-item :to="{ name: 'M_Simon says' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-account-voice</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Simon says</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemSimonSays',
    props: {
        disabled: Boolean,
    }
}
</script>